import { render, staticRenderFns } from "./SetDate.vue?vue&type=template&id=33ba7d98&scoped=true"
import script from "./SetDate.vue?vue&type=script&lang=js"
export * from "./SetDate.vue?vue&type=script&lang=js"
import style0 from "./SetDate.vue?vue&type=style&index=0&id=33ba7d98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba7d98",
  null
  
)

export default component.exports